/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UxpageUp } from '../../models/uxpage-up';

export interface GetChildNavigation$Params {
  parentUrl?: string | null;
}

export function getChildNavigation(http: HttpClient, rootUrl: string, params?: GetChildNavigation$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<UxpageUp>>> {
  const rb = new RequestBuilder(rootUrl, getChildNavigation.PATH, 'get');
  if (params) {
    rb.query('parentUrl', params.parentUrl, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<UxpageUp>>;
    })
  );
}

getChildNavigation.PATH = '/api/Navigation/list/child';
